import {
  GET_BRANCHES,
  GET_BRANCH,
  ADD_BRANCH,
  UPDATE_BRANCH,
  DELETE_BRANCH,
  BRANCH_ERROR,
  BRANCH_LOADING,
} from "../actions/types";

const initialState = {
  list: [],
  current: null,
  loading: false,
  error: null,
};

export default function branchReducer(state = initialState, action) {
  switch (action.type) {
    case BRANCH_LOADING:
      return { ...state, loading: true };
    case GET_BRANCHES:
      return { ...state, list: action.payload, loading: false };
    case GET_BRANCH:
      return { ...state, current: action.payload, loading: false };
    case ADD_BRANCH:
      return { ...state,  loading: false };
    case UPDATE_BRANCH:
      return {
        ...state,
       
        loading: false,
      };
    case DELETE_BRANCH:
      return {
        ...state,
        list: state.list.filter((b) => b._id !== action.payload),
        loading: false,
      };
    case BRANCH_ERROR:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
}
